import { shadows } from "../../themes/shadows/shadows.js";
import { typography } from "../../themes/typography/typography.js";
import "@mui/material";
import "../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../themes/typography/utils/typographyVariants/typographyVariants.js";
const avatarStyles = ({ variant, size, color }) => ({
  borderStyle: "solid",
  boxShadow: shadows["1"],
  boxSizing: "border-box",
  ...variant === "image" && {
    color: "grey.800",
    backgroundColor: "grey.300",
    borderColor: color === "light" ? "grey.100" : "grey.800"
  },
  ...variant === "initials" && {
    color: "primary.800",
    backgroundColor: "common.white",
    borderColor: "grey.100"
  },
  ...size === "xl" && {
    ...typography["Lato H4 Bold"],
    borderWidth: "4px",
    width: "88px",
    height: "88px",
    ".MuiSvgIcon-root": {
      width: "40px",
      height: "40px"
    }
  },
  ...size === "edit" && {
    ...typography["Lato H1"],
    borderWidth: "4px",
    width: "240px",
    height: "240px",
    ".MuiSvgIcon-root": {
      width: "120px",
      height: "120px"
    }
  },
  ...size === "l" && {
    ...typography["Lato H5 Bold"],
    borderWidth: "2px",
    width: "48px",
    height: "48px",
    ".MuiSvgIcon-root": {
      width: "24px",
      height: "24px"
    }
  },
  ...size === "m" && {
    ...typography["Lato Caption Bold"],
    borderWidth: "2px",
    width: "32px",
    height: "32px",
    ".MuiSvgIcon-root": {
      width: "20px",
      height: "20px"
    }
  },
  ...size === "s" && {
    ...typography["Lato Overline Bold"],
    borderWidth: "1px",
    width: "24px",
    height: "24px",
    ".MuiSvgIcon-root": {
      width: "16px",
      height: "16px"
    }
  },
  ...size === "xs" && {
    ...typography["Lato Overline Bold"],
    borderWidth: "1px",
    width: "16px",
    height: "16px",
    ".MuiSvgIcon-root": {
      width: "12px",
      height: "12px"
    }
  },
  ".MuiAvatar-fallback": {
    color: "grey.600"
  }
});
export {
  avatarStyles
};
